/* registration-form.js */
if (!customElements.get("registration-form")) {
  class RegistrationForm extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.btn = this.querySelector("#btn-submit-registration");
      this.spinner = this.querySelector("#reg-spinner");
      this.formContent = this.querySelector("#form-content");
      this.successState = this.querySelector("#reg-success");
      this.errorText = this.getAttribute("data-error-message");
      this.scriptUrl = this.getAttribute("data-url");

      this.initPhoneMask();
      this.initValidationListeners();
      this.initAppointmentRestriction();

      if (this.btn) {
        this.btn.addEventListener("click", () => this.handleRegistration());
      }
    }

    initPhoneMask() {
      const phoneInput = this.querySelector("#reg-phone");
      if (!phoneInput) return;

      phoneInput.addEventListener("input", (e) => {
        if (!e.target.value.startsWith("+90 ")) {
          e.target.value = "+90 ";
        }
        let val = e.target.value.substring(4).replace(/\D/g, "");
        if (val.length > 10) val = val.substring(0, 10);

        let final = "+90 ";
        if (val.length > 0) final += val.substring(0, 3);
        if (val.length > 3) final += " " + val.substring(3, 6);
        if (val.length > 6) final += " " + val.substring(6, 8);
        if (val.length > 8) final += " " + val.substring(8, 10);
        e.target.value = final;
        this.clearError(e.target, "err-phone");
      });
    }

    clearError(el, errId) {
      el.classList.remove("has-error");
      const errEl = this.querySelector(`#${errId}`);
      if (errEl) errEl.textContent = "";
    }

    formatDate(dateStr) {
      if (!dateStr) return "";
      const parts = dateStr.split("-");
      if (parts.length !== 3) return dateStr;
      return parts[2] + "." + parts[1] + "." + parts[0];
    }

    initValidationListeners() {
      const ids = [
        "reg-name",
        "reg-surname",
        "reg-phone",
        "reg-age",
        "reg-student-count",
        "reg-appointment",
        "reg-email",
        "reg-school",
        "reg-district",
      ];
      ids.forEach((id) => {
        const el = this.querySelector(`#${id}`);
        if (el) {
          const errId = "err-" + id.substring(4); // "reg-" sonrasının tamamı
          const handler = () => {
            if (el.value.trim() !== "" && el.value.trim() !== "+90") {
              this.clearError(el, errId);
            }
          };
          el.addEventListener("input", handler);
          el.addEventListener("blur", handler);
          el.addEventListener("animationstart", handler); // autofill algılama (CSS ile tetiklenir)
          if (el.tagName === "SELECT") el.addEventListener("change", handler);
        }
      });
    }

    initAppointmentRestriction() {
      const root = this;
      const input = this.querySelector("#reg-appointment");
      if (!input) return;

      const whenFlatpickrReady = (cb, attempts) => {
        attempts = attempts || 0;
        if (typeof flatpickr !== "undefined") {
          cb();
          return;
        }
        if (attempts > 50) {
          console.error(
            "[registration-form] flatpickr yüklenemedi (CDN engellenmiş olabilir).",
          );
          return;
        }
        setTimeout(() => whenFlatpickrReady(cb, attempts + 1), 100);
      };

      whenFlatpickrReady(() => {
        const allowedRaw = (
          root.getAttribute("data-allowed-weekdays") || "3,4"
        ).replace(/,$/, "");
        let allowedDays = allowedRaw
          .split(",")
          .filter(Boolean)
          .map((n) => parseInt(n.trim(), 10));
        if (allowedDays.length === 0) allowedDays = [3, 4];

        const dayNames = [
          "Pazar",
          "Pazartesi",
          "Salı",
          "Çarşamba",
          "Perşembe",
          "Cuma",
          "Cumartesi",
        ];
        const allowedNamesText = allowedDays.map((d) => dayNames[d]).join(", ");

        const hintEl = root.querySelector("#err-appointment");
        if (hintEl) {
          hintEl.style.color = "";
          hintEl.textContent =
            "Randevu yalnızca " + allowedNamesText + " günleri alınabilir.";
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        flatpickr(input, {
          locale:
            typeof flatpickr.l10ns !== "undefined" && flatpickr.l10ns.tr
              ? flatpickr.l10ns.tr
              : null,
          dateFormat: "Y-m-d",
          altInput: true,
          altFormat: "d.m.Y",
          minDate: today,
          disable: [(date) => allowedDays.indexOf(date.getDay()) === -1],
          onChange: () => {
            root.clearError(input, "err-appointment");
            if (hintEl)
              hintEl.textContent =
                "Randevu yalnızca " + allowedNamesText + " günleri alınabilir.";
          },
        });
      });
    }

    handleRegistration() {
      const fields = [
        { id: "reg-name", err: "err-name" },
        { id: "reg-surname", err: "err-surname" },
        { id: "reg-phone", err: "err-phone" },
        { id: "reg-age", err: "err-age" },
        { id: "reg-student-count", err: "err-student-count" },
        { id: "reg-appointment", err: "err-appointment" },
        { id: "reg-email", err: "err-email" },
        { id: "reg-school", err: "err-school" },
        { id: "reg-district", err: "err-district" },
      ];

      let hasError = false;
      fields.forEach((f) => {
        const el = this.querySelector(`#${f.id}`);
        if (!el) return;
        const val = el.value.trim();
        let invalid = false;

        if (!val || val === "" || val === "+90 ") invalid = true;

        if (f.id === "reg-email" && val !== "") {
          const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!re.test(val)) invalid = true;
        }

        if (f.id === "reg-phone") {
          const digits = el.value.replace(/\D/g, "");
          if (digits.length < 12) invalid = true;
        }

        if (f.id === "reg-student-count" && val !== "") {
          const num = Number(val);
          if (!Number.isInteger(num) || num < 1) invalid = true;
        }

        if (invalid) {
          el.classList.add("has-error");
          const errEl = this.querySelector(`#${f.err}`);
          if (errEl) errEl.textContent = this.errorText;
          hasError = true;
        }
      });

      if (hasError) return;

      this.btn.disabled = true;
      this.spinner.style.display = "block";

      let rawPhone = this.querySelector("#reg-phone").value;
      let excelPhone = "0" + rawPhone.replace("+90", "").trim();
      let randevuTarihiFormatted = this.formatDate(
        this.querySelector("#reg-appointment").value,
      );

      const formData = new URLSearchParams();
      formData.append("ad", this.querySelector("#reg-name").value.trim());
      formData.append("soyad", this.querySelector("#reg-surname").value.trim());
      formData.append("telefon", excelPhone);
      formData.append(
        "yasAraligi",
        this.querySelector("#reg-age").value.trim(),
      );
      formData.append(
        "ogrenciSayisi",
        this.querySelector("#reg-student-count").value.trim(),
      );
      formData.append("randevuTarihi", randevuTarihiFormatted);
      formData.append("email", this.querySelector("#reg-email").value.trim());
      formData.append("okul", this.querySelector("#reg-school").value.trim());
      formData.append(
        "ilIlce",
        this.querySelector("#reg-district").value.trim(),
      );
      formData.append("kayitTarih", new Date().toLocaleString("tr-TR"));

      fetch(this.scriptUrl, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      })
        .then(() => {
          this.formContent.style.display = "none";
          this.successState.style.display = "block";
        })
        .catch((err) => {
          console.error("Hata:", err);
          this.btn.disabled = false;
          this.spinner.style.display = "none";
          alert("Bir hata oluştu, lütfen tekrar deneyin.");
        });
    }
  }
  customElements.define("registration-form", RegistrationForm);
}
